import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import StockTech from './StockTech';
import SectorTech from './SectorTech';
import { getTickerInfo } from '../../actions';
import { calc } from '../Dashboard/Helpers';
import ShowLoading from '../../HOC/ShowLoading';
import SubNavStats from '../../components/SubNav/SubNavStats';
import './Stats.css';

const dropdownOptions = [
  { label: 'Stock statistics', value: 'stock' },
  { label: 'Sector statistics', value: 'sector' }
];

class Stats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentOption: dropdownOptions[0]
    };
  }

  onDropdownSelect = (value) => {
    this.setState({ currentOption: value });
  }

  showStats = () => {
    const { tickerInfo, sectorInfo, benchmarkInfo, quarterInfo } = this.props.user;
    const newTickerInfo = calc({ tickerInfo, sectorInfo, benchmarkInfo, quarterInfo });

    if (this.state.currentOption.value === 'stock') {
      return (
        <StockTech
          tickerInfo={newTickerInfo.tickerInfo} />
      );
    } else {
      return (
        <SectorTech
          sectorInfo={newTickerInfo.sectorInfo} />
      );
    }
  }

  render() {
    return (
      <Fragment>

        <SubNavStats
          dropdownOptions={dropdownOptions}
          currentOption={this.state.currentOption}
          onDropdownSelect={this.onDropdownSelect} />

        <Grid fluid className="technicals">
          {this.showStats()}
        </Grid>
        
      </Fragment>
    );
  }
}

function mapStateToProps({ user, auth, session }) {
  return {
    user,
    auth,
    session
  };
}

export default ShowLoading(connect(mapStateToProps, { getTickerInfo })(Stats));